<template>
  <div class="edit-table">
    <vxe-toolbar v-if="!disabled">
      <template v-slot:buttons>
        <vxe-button @click="addTable()">选择供货关系</vxe-button>
        <vxe-button @click="deleteTable()">清空</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      show-overflow=""
      ref="fineTable"
      :data="tableList"
      height="300px"
    >
      <vxe-table-column
        field="terminalCode"
        title="终端编码"
      ></vxe-table-column>
      <vxe-table-column
        field="terminalName"
        title="终端名称"
      ></vxe-table-column>
      <vxe-table-column v-if="type === 'update'" field="dealerName" title="经销商"></vxe-table-column>
      <vxe-table-column v-if="type === 'update'" field="productName" title="产品"></vxe-table-column>
      <vxe-table-column v-if="type === 'update'" field="salesmanName" title="业务员"></vxe-table-column>
      <vxe-table-column v-if="type === 'update'" field="positionName" title="职位"></vxe-table-column>
      <vxe-table-column v-if="type === 'add'" field="provinceName" title="省"></vxe-table-column>
      <vxe-table-column v-if="type === 'add'" field="cityName" title="市"></vxe-table-column>
      <vxe-table-column v-if="type === 'add'" field="districtName" title="区"></vxe-table-column>
      <vxe-column title="操作" width="80" v-if="!disabled">
        <template #default="{ row }">
          <template>
            <span
              @click="deletRow(row)"
              style="color: red; cursor: pointer"
              >删除</span
            >
          </template>
        </template>
      </vxe-column>
    </vxe-table>

    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import request from '@/found/utils/request';
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'Supplys',
  components: {
    SelectConfig,
  },
  props: {
    saveRef: Function,
    value: Array,
    disabled: Boolean,
    type: String,
    getRule: Function,
  },
  watch: {
    value() {
      this.tableList = this.value;
    },
    type: {
      deep: true,
      handler(newVal, oldVal) {},
      immediate: true,
    },
  },
  data() {
    return {
      tableList: [], // 当前关联费用科目数据
    };
  },
  mounted() {
    if (this.saveRef) {
      this.saveRef(this);
    }
  },
  methods: {
    // 删除行
    deletRow(row) {
      console.log(this.tableList);
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$refs.fineTable.remove(row);
        this.tableList.forEach((item, index) => {
          if (item.id === row.id) {
            this.tableList.splice(index, 1);
          }
        });
        this.$emit('change', this.tableList);
        this.$message({ type: 'success', message: '删除成功!' });
      });
    },

    // 清空列表
    deleteTable() {
      this.$refs.fineTable.remove();
      this.$emit('input', []);
      this.$emit('clear');
    },

    // 新增预算信息
    addTable() {
      const orgList = this.getRule('orgList').value;
      const customerList = this.getRule('customerList').value;
      const salesmanList = this.getRule('salesmanList').value;
      const seriesList = this.getRule('seriesList').value;
      const productList = this.getRule('productList').value;
      if (
        !(orgList && orgList.length)
        && !(customerList && customerList.length)
        && !(salesmanList && salesmanList.length)
        && !(seriesList && seriesList.length)
        && !(productList && productList.length)
      ) {
        this.$message({ type: 'warning', message: '请先选择查询参数' });
        return;
      }
      const params = {
        functionCode: 'supply_list',
        data: this.tableList,
        idKey: 'id',
        paramData: {
          isDefault: true,
          type: this.type,
        },
      };
      if (orgList && orgList.length) {
        params.paramData.orgList = orgList;
        params.paramData.isDefault = false;
      }
      if (customerList && customerList.length) {
        params.paramData.customerList = customerList;
        params.paramData.isDefault = false;
      }
      if (salesmanList && salesmanList.length) {
        params.paramData.salesmanList = salesmanList;
        params.paramData.isDefault = false;
      }
      if (seriesList && seriesList.length) {
        params.paramData.seriesList = seriesList;
        params.paramData.isDefault = false;
      }
      if (productList && productList.length) {
        params.paramData.productList = productList;
        params.paramData.isDefault = false;
      }
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      if (list1 && list1.length) {
        list1.forEach((v1) => {
          let notRepeat = true;
          const rowData = v1;
          for (const v2 in list2) {
            if (v1[key] === list2[v2][key]) {
              notRepeat = true;
              return false;
            }
          }
          if (notRepeat) {
            list.push(rowData);
          }
          return rowData;
        });
      }
      return list;
    },
    onGetSelect(val) {
      const data = this.getReset(val, [], 'id');
      this.$emit('input', data);
    },
  },
};
</script>

<style lang="less" scoped>
.edit-table {
  padding-left: 50px;
}
</style>
